import React from "react";
import { PrismicNextImage } from "@prismicio/next";
import * as s from "./socials.module.scss";

const Socials = ({ socials }) => {
  return (
    <div className={s.socials_wrapper}>
      <h3>Find us on</h3>
      <div className={s.socials_container}>
        {socials?.map(({ icon, link }, idx) => {
          return <SingleSocial key={idx} icon={icon} link={link} />;
        })}
      </div>
    </div>
  );
};

export default Socials;

const SingleSocial = ({ icon, link }) => {
  if (!link?.url) return;
  return (
    <a href={link?.url} target="_blank">
      <PrismicNextImage field={icon} width={24} height={24} />
    </a>
  );
};
